import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { fetchCustomers, fetchCustomersStatus } from '../../actions/customers_actions';
import { fetchPresidentDashInfo, fetchOverallPurchasePerformance } from '../../actions/purchaseOrders_actions';
import { fetchOverallSalesPerformance, fetchSalesTotals } from '../../actions/sales_actions';
import { fetchConsolidatedStatistics } from '../../actions/dashboard_actions';
import { fetchCustomerStatementList, fetchVendorStatementList } from '../../actions/arap_actions';

import PresidentDashboard from '../../components/Purchase/presidentDashboard';

const presidentDashboard = reduxForm({
  form: 'presidentDashboard',
})(PresidentDashboard);

const selector = formValueSelector('presidentDashboard');

function mapStateToProps(state) {
  const OverallPeriod = selector(state, 'OverallPeriod');
  const SalesPeriod = selector(state, 'SalesPeriod');

  return {
    OverallPeriod,
    SalesPeriod,

    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,

    presidentInfo: state.purchaseOrders.presidentInfo,
    presidentInfoIsLoading: state.purchaseOrders.presidentInfoIsLoading,
    presidentInfoError: state.purchaseOrders.presidentInfoError,

    overallSales: state.salesOrders.overallSales,
    overallSalesIsLoading: state.salesOrders.overallSalesIsLoading,
    overallSalesError: state.salesOrders.overallSalesError,

    overallPurchases: state.purchaseOrders.overallPurchases,
    overallPurchasesIsLoading: state.purchaseOrders.overallPurchasesIsLoading,
    overallPurchasesError: state.purchaseOrders.overallPurchasesError,

    customersStatuses: state.customers.customersStatuses,
    customersStatusesIsLoading: state.customers.customersStatusesIsLoading,
    customersStatusesError: state.customers.customersStatusesError,

    consolodatedStatistics: state.dashboard.consolodatedStatistics,
    consolodatedStatisticsIsLoading: state.dashboard.consolodatedStatisticsIsLoading,
    consolodatedStatisticsError: state.dashboard.consolodatedStatisticsError,

    customerStatementListIsLoading: state.arap.customerStatementListIsLoading,
    customerStatementList: state.arap.customerStatementList,
    customerStatementListError: state.arap.customerStatementListError,

    salesTotals: state.salesOrders.salesTotals,
    salesTotalsIsLoading: state.salesOrders.salesTotalsIsLoading,
    salesTotalsError: state.salesOrders.salesTotalsError,

    vendorStatementListIsLoading: state.arap.vendorStatementListIsLoading,
    vendorStatementList: state.arap.vendorStatementList,
    vendorStatementListError: state.arap.vendorStatementListError,

    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  fetchSalesTotals,
  fetchCustomers,
  fetchPresidentDashInfo,
  fetchOverallPurchasePerformance,
  fetchOverallSalesPerformance,
  fetchCustomersStatus,
  fetchConsolidatedStatistics,
  fetchCustomerStatementList,
  fetchVendorStatementList,
})(presidentDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/presidentDashboard.jsx